import api from "./api";

class NonInteressatoBusinessUnitsManager {

    businessUnits(config?: any) {
        return api.get(`/non_interessato`, config)
    }

    nonInteressato(cliente_id: number | string) {
        return api.get(`/clienti/${cliente_id}/non_interessato`)
    }

    retrieve = this.nonInteressato
    list = this.businessUnits
}

const nonInteressatoBusinessUnitsManager = new NonInteressatoBusinessUnitsManager()

export default nonInteressatoBusinessUnitsManager
